import { GetTeamAuditHistoryResponse } from '@cbinsights/userv2service/userv2service';
import { UseQueryResult, useQuery } from 'react-query';
import { GetTeamAuditHistory } from '.';
import { getTeamAuditHistory } from '../api/GetTeamAuditHistory';

type Params = Parameters<typeof getTeamAuditHistory>[0];
type Return = GetTeamAuditHistoryResponse;

export const useGetTeamAuditHistory = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetTeamAuditHistory, Params]>(
    ['GetTeamAuditHistory', params],
    () => getTeamAuditHistory(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
